export const defaultValues = {
  name: '',
  description: '',
  logo: null,
  location_ids: [] as string[],
};
